import { Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import Typography from "@/components/ui/typography";

import { MarketplaceProfileTestimonial } from "../../types/marketplace-testimonials";

interface TestimonialCardProps {
  testimonial: MarketplaceProfileTestimonial;
  onDelete?: (testimonialId: string) => void;
  isDeleting?: boolean;
}

const TestimonialCard = ({
  testimonial,
  onDelete,
  isDeleting,
}: TestimonialCardProps) => {
  return (
    <div className="bg-white border border-[#e5e5e5] rounded-xl p-4 space-y-3">
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <Typography size="l2" className="font-semibold text-[#1e1e24]">
            {testimonial.name}
          </Typography>
          <Typography size="b2" className="text-[#767677]">
            {testimonial.company}
          </Typography>
        </div>
        {onDelete && (
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 text-[#767677] hover:text-red-500"
            onClick={() => onDelete(testimonial._id)}
            disabled={isDeleting}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        )}
      </div>

      <Typography size="b2" className="text-[#494949] line-clamp-4">
        {testimonial.content}
      </Typography>
    </div>
  );
};

export default TestimonialCard;
